import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Parameters } from '../../../../../../../core/entities/parameters.model';
import { ParametersService } from '../../../../../../../core/repositories/parameters.service';
import { TIPO_DATO_PARAM } from '../../../../../../../core/utils/constants';

@Injectable()
export class EditDialogsParametersService {

  parameters: Parameters = new Parameters();
  originalParameters: Parameters = new Parameters();
  parametersInput: Parameters = new Parameters();

  allParametres: Parameters[] = [];
  changetitulo: boolean = false;

  tipodato: any[] = TIPO_DATO_PARAM;

  constructor(private parametersService: ParametersService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.parameters = data.parametro;
    this.changetitulo = data.titulochange;
    this.originalParameters = _.cloneDeep(this.parameters);
    console.log(data);
    return this.parametersService.findAll().pipe(map((result: Parameters[]) => {
      this.allParametres = result;
      if (Utils.noUndfAndNull(data.parametro)) {
        this.parameters = _.cloneDeep(data.parametro);
      }
      return true;
    }));
  }


  /**
  * @description
  * Guarda el parametro
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.parameters.id, "")) {

      /*comparamos el parametro original con el modificado*/
      let compareParameter = this.compare(this.parameters, this.originalParameters);

      if(compareParameter){
        return of(-1);
      }else{
        return this.parametersService.postParameter(this.parameters);
      }

    }else{
      return this.parametersService.postParameter(this.parameters);
    }
  }

  /**
  * @description
  * Comprueba si dos Parametros son iguales.
  * @param datoX Parametro 1
  * @param datoY Parametro 2
  * @returns True si son iguales
  */
  public compare(itemX:Parameters, itemY:Parameters):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if (itemX.typevalue !== null) {
        let value = itemX.typevalue.toString();
        if (value === 'null') {
          itemX.typevalue = 0;
        }
      }

      if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)
        || !Utils.compareTextOrNumber(itemX.desc, itemY.desc)
        || !Utils.compareTextOrNumber(itemX.value, itemY.value)
        || !Utils.compareTextOrNumber(itemX.typevalue, itemY.typevalue))
        && (itemX.code !== "" && Utils.noUndfAndNull(itemX.typevalue)))
          return false;
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
      return false;
    }
    return true;
 }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.parameters = new Parameters();
  }

}
